import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Shot } from 'src/app/components/company/models/new/shot'; 
import { Selectable } from '../../types/selectable.type';

@Component({
	selector: 'bt-image-gallery',
	standalone: false,
	templateUrl: './image-gallery.component.html',
	styleUrl: './image-gallery.component.scss'
})
export class ImageGalleryComponent {
	readonly #dialogRef = inject(MatDialogRef<ImageGalleryComponent>);
	readonly data = inject<any>(MAT_DIALOG_DATA);
	shots: Selectable<Shot>[] = [];

	constructor() {
		if (this.data && this.data.shots) {
			console.log('Received shots:', this.data);
			this.shots = this.data.shots.map((shot: Shot) => ({ ...shot, selected: false }));
			if (this.shots.length > 0) {
				this.shots[0].selected = true;
			}
		}
	}

	goPrevious() {
		const currentIndex = this.shots.findIndex((shot) => shot.selected);
		if (currentIndex > 0) {
			this.shots[currentIndex].selected = false;
			this.shots[currentIndex - 1].selected = true;
		}
	}

	goNext() {
		const currentIndex = this.shots.findIndex((shot) => shot.selected);
		if (currentIndex < this.shots.length - 1) {
			this.shots[currentIndex].selected = false;
			this.shots[currentIndex + 1].selected = true;
		}
	}

	isLast(): boolean {
		const currentIndex = this.shots.findIndex((shot) => shot.selected);
		return currentIndex === this.shots.length - 1;
	}

	isFirst(): boolean {
		const currentIndex = this.shots.findIndex((shot) => shot.selected);
		return currentIndex === 0;
	}

	close() {
		this.#dialogRef.close();
	}
}
